import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import DeviceGroupsList from './DeviceGroupsList';
import { pushHistory } from 'src/module/navigation/action';
import { useDispatch } from 'react-redux';
import Button from 'src/component/UI/Button';
import { isWhitelabel } from 'src/utils/utils';
import PermissionFence from 'src/component/PermissionFence';
import { useTranslation } from 'src/i18n';

export default function DeviceGroupScreen () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const createGroup = () => {
    dispatch(pushHistory(`/devices/list/create-group`));
  };
  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';
  return (
    <div className='page' id='loto-screen'>
      <Helmet>
        <title>{title} - {t('deviceGroups.title')}</title>
      </Helmet>
      <Paper>
        <h2>{t('deviceGroups.title')}</h2>
        <div style={{ display: 'flex', float: 'right' }}>
          <PermissionFence can={['edit-device']} >
            <Button cta onClick={createGroup}>{t('deviceGroups.selectDevicesForNewGroup')}</Button>
          </PermissionFence>

        </div>
        <DeviceGroupsList />

      </Paper>
    </div>
  );
}
